var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "pay-in-test" },
    [
      _c(
        "a-form-model",
        {
          ref: "form",
          attrs: {
            form: _vm.form,
            layout: "vertical",
            rules: _vm.rules,
            model: _vm.saveObject,
          },
        },
        [
          _c(
            "a-form-model-item",
            { attrs: { label: "应用选择", prop: "appId" } },
            [
              _c(
                "a-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "请选择应用" },
                  on: { change: _vm.handleAppChange },
                  model: {
                    value: _vm.saveObject.appId,
                    callback: function ($$v) {
                      _vm.$set(_vm.saveObject, "appId", $$v)
                    },
                    expression: "saveObject.appId",
                  },
                },
                _vm._l(_vm.appList, function (app) {
                  return _c(
                    "a-select-option",
                    { key: app.appId, attrs: { value: app.appId } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(app.appName) +
                          " [" +
                          _vm._s(app.appId) +
                          "] "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: "代收通道", prop: "wayCode" } },
            [
              _c(
                "a-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    placeholder: "请选择代收通道",
                    disabled: !_vm.saveObject.appId,
                  },
                  model: {
                    value: _vm.saveObject.wayCode,
                    callback: function ($$v) {
                      _vm.$set(_vm.saveObject, "wayCode", $$v)
                    },
                    expression: "saveObject.wayCode",
                  },
                },
                _vm._l(_vm.channelList, function (channel) {
                  return _c(
                    "a-select-option",
                    { key: channel.wayCode, attrs: { value: channel.wayCode } },
                    [_vm._v(" " + _vm._s(channel.wayCode) + " ")]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: "金额(元)", prop: "amount" } },
            [
              _c("a-input-number", {
                staticStyle: { width: "100%" },
                attrs: {
                  min: 0.01,
                  max: 100000,
                  precision: 2,
                  placeholder: "请输入金额",
                },
                model: {
                  value: _vm.saveObject.amount,
                  callback: function ($$v) {
                    _vm.$set(_vm.saveObject, "amount", $$v)
                  },
                  expression: "saveObject.amount",
                },
              }),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            { attrs: { label: "回调地址", prop: "notifyUrl" } },
            [
              _c("a-input", {
                attrs: { placeholder: "请输入回调地址", allowClear: "" },
                model: {
                  value: _vm.saveObject.notifyUrl,
                  callback: function ($$v) {
                    _vm.$set(_vm.saveObject, "notifyUrl", $$v)
                  },
                  expression: "saveObject.notifyUrl",
                },
              }),
            ],
            1
          ),
          _c(
            "a-form-model-item",
            [
              _c(
                "a-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v(" 提交测试 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.result
        ? _c(
            "div",
            { staticClass: "result-container" },
            [
              _c("a-divider", [_vm._v("测试结果")]),
              _c("a-alert", {
                attrs: {
                  type: _vm.result.code === 0 ? "success" : "error",
                  message: _vm.result.code === 0 ? "测试成功" : "测试失败",
                  description: _vm.result.msg,
                  "show-icon": "",
                },
              }),
              _vm.result.code === 0
                ? _c(
                    "a-descriptions",
                    {
                      staticStyle: { "margin-top": "20px" },
                      attrs: { title: "订单信息", bordered: "", column: 1 },
                    },
                    _vm._l(_vm.result.data, function (value, key) {
                      return _c(
                        "a-descriptions-item",
                        { key: key, attrs: { label: key } },
                        [
                          _vm._v(" " + _vm._s(value) + " "),
                          key === "payUrl"
                            ? [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "link" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleCopy(value)
                                      },
                                    },
                                  },
                                  [_vm._v("复制")]
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      )
                    }),
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }